export const useManagedQueryFailed = "Pg0si";
export const useManagedQuerySubmitFeedback = "jwzDF";
export default {useManagedQueryFailed,useManagedQuerySubmitFeedback};